export const state = () => ({
  counter: 0
})

// getters派生/计算属性
export const getters = {
  getCounter(state) {
    return state.counter
  }
}

// mutations只能同步操作
export const mutations = {
  increment(state) {
    state.counter++
  }
}

// actions主要是异步操作
export const actions = {
  async fetchCounter({ state }) {
    // make request
    const res = { data: 10 };
    state.counter = res.data;
    return res.data;
  }
}